import { observer } from "mobx-react-lite"
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import gsap from 'gsap';

const MultiSwitcherStage = ({ values, selectValue, defaultValue, backIsWhite, forceSelected, isInner, disabled }) => {
    const [selected, setSelected] = useState(defaultValue ? defaultValue : 0);
    const params = useRef([]);
    const background = useRef(null);

    useLayoutEffect(() => {
        toggleValue(forceSelected ? forceSelected : (defaultValue ? defaultValue : 0))
    }, [forceSelected]);

    const toggleValue = (index) => {
        setSelected(index);
        selectValue(index);
        
        const selectedParam = params.current[index];
        // const selectedRect = selectedParam.getBoundingClientRect();
        // const containerRect = selectedParam.parentElement.getBoundingClientRect();
        
        // const targetX = selectedRect.left - containerRect.left;
        // const targetWidth = selectedRect.width;
        
        const targetX = selectedParam.offsetLeft;
        const targetWidth = selectedParam.offsetWidth;

        gsap.to(background.current, {
            x: targetX,
            width: targetWidth,
            duration: .15,
            ease: 'power2.inOut',
        });
    }

    return (
        <ul className={backIsWhite ? "switcher dark" : "switcher"} id="rateOprions_multiSwitcher" onMouseDown={(e) => e.preventDefault()}>
            <div ref={background} className="bg"></div>
            {values && values.length > 0 && values.map((item, index) => 
                <li 
                    ref={(el) => (params.current[index] = el)} 
                    onClick={() => !disabled && toggleValue(index)} 
                    className={`${(forceSelected != undefined && forceSelected == index) || (forceSelected == undefined && selected == index) ? "active" : ""}`}
                    key={item+index}
                >{item.name}</li>
            )}
            {/* <li ref={param2} onClick={() => { toggleValue(true); onClickSecond() }}  className={`${isFirst ? "active" : ""}`}>{name2}</li> */}
        </ul>
    )
}

export default observer(MultiSwitcherStage);
